<form [formGroup]="rangeForm" class="date-range-form">
  <mat-form-field appearance="outline" class="form-field combined-range">
    <mat-label>Date Range</mat-label>
    <input matInput [value]="displayValue" readonly (click)="openDialog()" placeholder="Select date range">
  </mat-form-field>
</form> 